import { useEffect } from "react";
import { Link } from "react-router-dom";
import { approach, destinations, featuredTours } from "../data/site";
import "./home.css";

function HomePage() {
  useEffect(() => {
    document.title = "Mirrorkhan Tours";
  }, []);

  return (
    <div className="home">
      <section className="home-hero" aria-label="Introduction">
        <div className="home-hero__media" aria-hidden="true">
          <img
            src="https://images.unsplash.com/photo-1506929562872-bb421503ef21?auto=format&fit=crop&w=2000&q=80"
            alt=""
          />
        </div>
        <div className="home-hero__shade" aria-hidden="true" />
        <div className="container home-hero__content">
          <div className="row">
            <div className="col-12 col-md-10 col-lg-7 col-xl-6 mk-hero-enter">
              <h1>Zanzibar, at an unhurried pace.</h1>
              <p className="home-hero__lede">
                Island stays, Stone Town walks, and Tanzania trips shaped around
                the coast you came for.
              </p>
              <div className="home-hero__actions d-flex flex-wrap gap-3">
                <Link className="btn btn-mk-gold" to="/tours">
                  View tours
                </Link>
                <Link className="btn btn-mk-ghost" to="/contact">
                  Plan a trip
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-block home-section--soft">
        <div className="container">
          <div
            className="row justify-content-between align-items-end g-3 mb-4 mb-lg-5"
            data-reveal="true"
          >
            <div className="col-lg-8">
              <p className="eyebrow">Destinations</p>
              <h2 className="mb-0">Tanzania, with Zanzibar at the center.</h2>
            </div>
            <div className="col-lg-auto">
              <Link className="text-link" to="/destinations">
                All destinations
              </Link>
            </div>
          </div>

          <div className="row g-4">
            {destinations.map((place, index) => (
              <div
                className="col-12 col-md-4"
                key={place.name}
                data-reveal="true"
                data-reveal-delay={String(index * 90)}
              >
                <Link
                  to={`/destinations#${place.name
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                  className="place-tile"
                >
                  <img src={place.image} alt={place.imageAlt} loading="lazy" />
                  <div className="place-tile__copy">
                    <h3 className="h4 mb-1">{place.name}</h3>
                    <p className="mb-0">{place.line}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-block">
        <div className="container">
          <div
            className="row justify-content-between align-items-end g-3 mb-4 mb-lg-5"
            data-reveal="true"
          >
            <div className="col-lg-7">
              <p className="eyebrow">Featured tours</p>
              <h2 className="mb-3">Tours built around Zanzibar.</h2>
              <p className="section-copy mb-0">
                Beach days, town days, and optional mainland safari. Dates flex
                with the season. Groups stay small.
              </p>
            </div>
            <div className="col-lg-auto">
              <Link className="text-link" to="/tours">
                See all tours
              </Link>
            </div>
          </div>

          <div className="row g-4">
            {featuredTours.map((tour, index) => (
              <div
                className="col-12 col-md-6 col-lg-4"
                key={tour.id}
                data-reveal="true"
                data-reveal-delay={String(index * 90)}
              >
                <article className="tour-tile h-100">
                  <Link to={`/tours/${tour.id}`} className="tour-tile__link">
                    <div className="tour-tile__media">
                      <img
                        src={tour.image}
                        alt={tour.imageAlt}
                        loading="lazy"
                      />
                    </div>
                    <div className="tour-tile__body">
                      <h3 className="h4 mb-2">{tour.title}</h3>
                      <p className="tour-tile__meta mb-2">
                        {tour.days} days · {tour.place}
                      </p>
                      <p className="tour-tile__summary mb-0">{tour.summary}</p>
                    </div>
                  </Link>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-block home-section--soft">
        <div className="container">
          <div className="row mb-4 mb-lg-5" data-reveal="true">
            <div className="col-lg-7">
              <p className="eyebrow">How we work</p>
              <h2 className="mb-0">Quiet confidence on the island and beyond.</h2>
            </div>
          </div>

          <div className="row g-4">
            {approach.map((item, index) => (
              <div
                className="col-12 col-md-4"
                key={item.title}
                data-reveal="true"
                data-reveal-delay={String(index * 100)}
              >
                <article className="approach-item h-100">
                  <span className="approach-item__num">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h3 className="h4 mb-2">{item.title}</h3>
                  <p className="mb-0">{item.text}</p>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="home-close" data-reveal="fade">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-8">
              <p className="eyebrow eyebrow--light">Ready when you are</p>
              <h2 className="mb-3">Tell us the month. We shape the route.</h2>
              <p className="mb-0 home-close__copy">
                Write with who is traveling and how you like to spend a day. A
                planner replies with a clear plan and a real price.
              </p>
            </div>
            <div className="col-lg-4 text-lg-end">
              <Link className="btn btn-mk-gold" to="/contact">
                Contact the desk
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
